import React, { Component } from 'react';
import { connect } from 'react-redux';

import { addAirwayBillPartToCart } from '../../../store/actions/cartAction';

import Awb from '../../../models/Awb';
import AwbPart, { AwbPartStatuses } from '../../../models/AwbPart';
import CartItem, { CartItemPart } from '../../../models/CartItem';
import AddAWBModal from './AddAWBModal';

import { AWB_SCHEMA } from '../../../utils/airwayBill';
import { getAwbPartStatuses } from '../../../store/actions/awbPartStatusesAction';
import userManagementReqHandler from '../../../api/userManagementRemote';
import AirlineType from '../../../models/AirlineType';
import ResponseError from '../../../models/ResponseError';
import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';
import awbRemote from '../../../api/awbRemote';
import ApiResponse from '../../../models/ApiResponse';
import User from '../../../models/User';

interface AddAWBModalContainerState {
  awb: Awb;
  refresh: boolean;
  errorMsg: {
    pieces: string;
    weight: string;
    add: string;
  },
  checkClose: boolean;
  errorClose: string;
  validation: boolean;
  airlines: AirlineType[];
  partErrorMsg: string;
  notDelivered: NotDeliveredPart;
  disableUpdate: boolean;
};

interface AddAWBModalContainerProps {
  classes?: any;
  modalOpen: boolean;
  awb: Awb;
  handleSave: Function;
  handleSync?: Function;
  handleCloseModal: Function;
  addAWBPartToCart: Function;
  getAvailableAwbPartStatuses: Function;
  cart: Array<CartItem>;
  awbActionOfUpdateButton: 'add' | 'update';
  availableAwbPartStatuses: AwbPartStatuses;
  manualEntry?: boolean;
  awbInfo?: boolean;
  receiveSuccess: Function;
  receiveError: Function;
  user: User;
  clearAwb?: () => void; 
  handleOpenPoD: (code: string, number: string, version: number) => void;
};

interface NotDeliveredPart {
  not_delivered_pieces: number,
  not_delivered_weight: number
}

class AddAWBModalContainer extends Component<AddAWBModalContainerProps, AddAWBModalContainerState> { 

  isTrueFlag = (value: any): boolean => value === true || value === 1 || value === '1' || value === 'true';
  hasOrderLink = (part: any): boolean => {
    const hasOrderInfo = !!(part?.order_info && (part.order_info.order_number || part.order_info.delivered_date));
    return hasOrderInfo || this.isTrueFlag(part?.in_order) || !!part?.id_order;
  }
  hasDeliveredOrderInfo = (part: any): boolean => !!(part?.order_info && part.order_info.delivered_date);
  isDeliveredPart = (part: any): boolean => this.hasDeliveredOrderInfo(part) || (this.isTrueFlag(part?.delivered) && this.hasOrderLink(part));
  isInExistingOrder = (part: any): boolean => this.isTrueFlag(part?.in_order)

  state = {
    awb: AWB_SCHEMA,
    refresh: true,
    errorMsg: {
      pieces: '',
      weight: '',
      add: ''
    },
    checkClose: true,
    errorClose: '',
    validation: false,
    airlines: [],
    partErrorMsg: '',
    notDelivered: {
      not_delivered_pieces: 0,
      not_delivered_weight: 0
    },
    disableUpdate: false,
  };

  componentDidMount() {
    
    if(this.props.availableAwbPartStatuses.import.length === 0) {
      this.props.getAvailableAwbPartStatuses();
    }
    if(this.props.user.role !== 'forwarder')
      this.getGhaAirlines();
    const notDelivered = this.state.notDelivered;
    if(this.props.awb.import_parts) {
      this.props.awb.import_parts.forEach((element: any) => {
        const inOrder = this.isInExistingOrder(element);
        const delivered = this.isDeliveredPart(element);
        const cart = this.isTrueFlag(element.cart);
        const singlePartAutoSelect = this.props.awb.allowed_ops.add_awb_cart && this.props.awb.import_parts.length === 1;
        notDelivered.not_delivered_pieces += element.not_delivered_pieces ? element.not_delivered_pieces : 0;
        notDelivered.not_delivered_weight += element.not_delivered_weight ? element.not_delivered_weight : 0;
        element.flight = element.flight_no ? element.flight_no.substring(0, 2) : '';
        element.number = element.flight_no ? element.flight_no.substring(2) : '';
        element.in_order = inOrder;
        element.delivered = delivered;
        element.cart = cart;
        element.added = !delivered && !inOrder && (cart || singlePartAutoSelect);
      });
    }
    this.setState({ awb: this.props.awb, notDelivered }, async() => {
      await this.onValidationPcs();
      await this.onValidationWgt();
    }); 
  };

  onValidationPcs = (): void => { 

    let totalPcs: number = +this.state.awb.pieces;
    let sum: number = this.state.awb.import_parts.reduce((total, part) => { 
       return (total + +(Number(part.pieces) - (part.not_delivered_pieces && this.state.awb.import_parts.length > 1 ? part.not_delivered_pieces : 0)))
    }, 0);

    if (sum !== totalPcs) {
      this.setState({
        errorMsg: {
        ...this.state.errorMsg,
        pieces: 'Тhe total number of pieces does not match the sum of the pieces in the parts!'
        },
        validation: true
      });
    } else {
      this.setState({
        errorMsg: {
          ...this.state.errorMsg,
          pieces: ''
        },
        validation: false
      });
    }
  };
  
  onValidationWgt = (): void => { 
    
    let totalWeight: number = +(this.state.awb.weight);
    let sum: number = this.state.awb.import_parts.reduce((total, part) => { 
      return (total + +(Number(part.weight) - (part.not_delivered_weight && this.state.awb.import_parts.length > 1 ? part.not_delivered_weight : 0)));
    }, 0);
  
    if (sum !== totalWeight) {
      this.setState({
        errorMsg: {
           ...this.state.errorMsg,
          weight: 'The total weight is not equal to the sum of the weights of the parts!'
        },
        validation: true
      });
    } else {
      this.setState({
        errorMsg: { ...this.state.errorMsg, weight: '' },
        validation: false
      });
    };
  };

  handleChange = (name: string, event: any): any => {

    const value: string = event.target.value.toUpperCase(); 
    let awb: Awb = { ...this.state.awb }; 

    switch (name) {
        case 'pieces': awb.pieces = value ; break;
        case 'weight': awb.weight = value; break;
        case 'origin': awb.origin = value.trim().substr(0, 3); break;
        case 'destination': awb.destination = value.trim().substr(0, 3); break;
        default: return;
    }

    this.setState({ awb, refresh: false });
  };

  deletePart = (id: number): void => {
    awbRemote.deleteImportPart(id).then((resp: ApiResponse<boolean>) => {
      const parts: boolean | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  validateSave = (awbData: Awb, opt: {edit: boolean, metadata: boolean}): void => {
    let valid = false;
    let partErrorMsg = '';
    if(!this.state.validation) {
      for (let i = 0; i < this.state.awb.import_parts.length; i++) {
        const part = this.state.awb.import_parts[i];
        if (part.flight_date === 'NaNaNaN' || part.arrival_date === 'NaNaNaN') {
          valid = false;
          partErrorMsg = 'One or more parts have invalid flight date or arrival date';
          break;
        }
      
        if (part.added && part.flight_date !== 'NaNaNaN' && part.arrival_date !== 'NaNaNaN') {
          valid = true;
        }
      }
      if(valid || this.props.awbInfo) {
        this.setState({ disableUpdate: true });
        const res = this.props.handleSave(awbData, opt);
        if (res && res.then) {
          res.then(() => this.setState({ disableUpdate: false }))
             .catch(() => this.setState({ disableUpdate: false }));
        }
        
        if(this.props.clearAwb) {
          this.props.clearAwb();
        }
      } else {
        partErrorMsg = 'Please select part';
      }
      this.setState({ partErrorMsg });
    }

  }

  getGhaAirlines = () => {
    userManagementReqHandler.getAirlines().then(resp => {
      const airlines: Array<AirlineType> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(airlines) {
        this.setState({ airlines: airlines });
      }
    })
  }

  handleClose = (modalType: string): void => {

    if (this.state.checkClose && !this.state.refresh) {

      this.setState({
        checkClose: false,
        errorClose: 'Your updates will be lost. If you want to keep changes, select "Update", if you want to exit without saving, select "X"'
      });
    } else {

      this.setState({ checkClose: true, errorClose: '', refresh: true });
      this.props.handleCloseModal(modalType);
    };
  };

  enableCartIcon = (awbPart: AwbPart): boolean => {

    const foundCart: CartItem | undefined = this.findInCart(this.state.awb.code, this.state.awb.number);
    let enable: boolean = true;

    if (foundCart) {

      const parts: Array<CartItemPart> = foundCart.parts;

      for (const part of parts) {

        if (part.id === awbPart.id) {
          enable = false;
          break;
        };
      };
    };

    return enable;
  };

  findInCart = (code: string, number: string): CartItem | undefined => {

    return this.props.cart.find((cartElement: CartItem) => {
      return cartElement.code === code && cartElement.number === number;
    });
  };

  addPartToCart = (awbPart: AwbPart): void => {
    if(!this.isInExistingOrder(awbPart) && !this.isDeliveredPart(awbPart)) {
      const awb = { ...this.state.awb };
      awb.import_parts.forEach((element: AwbPart) => {
        if(element.flight_no + element.flight_date === awbPart.flight_no + awbPart.flight_date) {
          element.added = !this.isTrueFlag((element as any).added);
          element.cart = false;
        }
      });
      this.setState({ awb });
    }
  };



  setContainerState = (data: any): void => {
    const { awb } = data
    if (awb) {
    if (this.props.manualEntry) {
      let sumPcs: number = awb.import_parts.reduce((total: number, part: any) => {
        return total + (Number(part.pieces) - (part.not_delivered_pieces || 0));
      }, 0);

      let sumWgt: number = awb.import_parts.reduce((total: number, part: any) => {
        return total + (Number(part.weight) - (part.not_delivered_weight || 0));
      }, 0);
      awb.pieces = sumPcs;
      awb.weight = sumWgt;
    }
    this.setState({awb, refresh: false });
  } else {
    this.setState(data);
  }
  };

  render() {
    const manager = this.props.user.roleName === 'GHA Manager' || this.props.user.roleName === 'GHA Supervisor';
    return (
      <AddAWBModal
        errorMsg={ this.state.errorMsg }
        awb={ this.state.awb }
        refresh={ this.state.refresh }
        handleChange={ this.handleChange }
        onValidationPcs={ this.onValidationPcs }
        onValidationWgt={ this.onValidationWgt }
        availableAwbPartStatusesForProcess={ this.props.availableAwbPartStatuses.import }
        handleClose={ this.handleClose }
        handleSync={ this.props.handleSync }
        modalOpen={ this.props.modalOpen }
        setState={ this.setContainerState }
        enableCartIcon={ this.enableCartIcon }
        handleSave={ this.validateSave }
        errorClose={ this.state.errorClose }
        awbActionOfUpdateButton={ this.props.awbActionOfUpdateButton }
        manualEntry={ this.props.manualEntry }
        airlines={ this.state.airlines }
        addPart={ this.addPartToCart }
        deletePart={ this.deletePart }
        handleOpenPoD={ this.props.handleOpenPoD }
        awbInfo={ this.props.awbInfo }
        partErrorMsg={ this.state.partErrorMsg }
        notDelivered={ this.state.notDelivered }
        userRole={ this.props.user.role }
        managerAccess={manager}
        disableUpdate={ this.state.disableUpdate }
      />
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    cart: state.cart.items,
    availableAwbPartStatuses: state.awbPartStatuses,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getAvailableAwbPartStatuses: () => dispatch(getAwbPartStatuses()),
    addAWBPartToCart: (code: string, number: string, partId: string) => dispatch(addAirwayBillPartToCart(code, number, partId)),
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAWBModalContainer);